'use strict';
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/fails.js
// module id = 19
// module chunks = 0